import React from 'react';
import { Button } from '@chakra-ui/react';

interface props {
  buttonClick: () => void;
  buttonText: string;
}

export const LocationHeaderButton: React.FC<props> = (props) => {
  const { buttonClick, buttonText } = props;

  return (
    <Button
      mr='10'
      fontSize='20px'
      bg='transparent'
      _hover={{ bg: 'transparent' }}
      _focus={{ bg: 'transparent' }}
      color='white'
      onClick={() => buttonClick()}
    >
      {buttonText}
    </Button>
  );
};
